import { useState, useEffect } from "react";
import MobilityContractPayoutConfig from "../../models/MobilityContractPayoutConfig";
import MobilityContractPayoutConfigsService from "../../services/crud/MobilityContractPayoutConfigService";
import { DatePicker, Form, FormInstance, Input, Spin, Tooltip } from "antd";
import { LoadingOutlined, QuestionCircleFilled } from "@ant-design/icons";
import { EntitySelector } from "./selects/EntitySelector";
import moment from "moment";
import { LangKeyList } from "../../models/LangKey";
import { LocalizedField } from "./inputs/LocalizedField";

export const MobilityContractPayoutConfigFormGenericForm = (props) => {
  const form: FormInstance = props.form;
  const id = props.id;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.resetFields();
    if (id) {
      setLoading(true);
      MobilityContractPayoutConfigsService.getMobilityContractPayoutConfig(id).then((data) => {
        setLoading(false);
        data.walletPayoutMessage = data.walletPayoutMessage ? JSON.parse(data.walletPayoutMessage) : {};
        form.setFieldsValue(data);
      });
    }

    // Load data
  }, [form, id]);

  if (loading) {
    return <></>;
  }

  const content = (
    <Form<MobilityContractPayoutConfig> form={form} layout="vertical">
      <Form.Item noStyle name="id">
        <Input type="hidden" />
      </Form.Item>

      <Form.Item noStyle name="accountId">
        <Input type="hidden" />
      </Form.Item>

      <Form.Item label="Wallet Payout Amount (cents)" name="walletPayoutAmountCents" required
        rules={[{ required: true }]}
      >
        <Input type="number" />
      </Form.Item>
      <Tooltip title="Wallet payout amount in cents">
        <QuestionCircleFilled />
      </Tooltip>

      <Form.Item label="Max number of payouts per apartment" name="maxMobilityContractPayoutsPerApartment">
        <Input type="number" />
      </Form.Item>
      <Tooltip title="If set, gives the maximum number of contracts (tenants) that can receive this Mobility payout. If a contract has multiple tenants it still count only on towards this limit.">
        <QuestionCircleFilled />
      </Tooltip>

      <LocalizedField
        supportedLanguages={LangKeyList}
        name="walletPayoutMessage"
        inputType="input"
        label="Wallet payout message"
        placeholder=" "
        minLabelWidth={20}
      />
      <Tooltip title="This message is saved into the wallet transaction and is also included in the wallet transaction email">
        <QuestionCircleFilled />
      </Tooltip>
    </Form>
  );

  if (loading) {
    return (
      <Spin size="large" tip="Loading" indicator={<LoadingOutlined />}>
        {content}
      </Spin>
    );
  }
  return content;
};

